<script>
import { mapActions } from "vuex";
import OrderDetails from "./OrderDetails";
import OrderPayments from "./OrderPayments";
import Events from "./Events/Index";

export default {
  components: {
    OrderDetails,
    OrderPayments,
    Events
  },

  data() {
    return {
      preloader: false,
      order: null,
      payments: []
    };
  },
  methods: {
    ...mapActions("orders", ["getById"]),
    async getOrder(id) {
      this.preloader = true;

      try {
        let res = await this.getById(id);
        this.preloader = false;
        return res;
      } catch (error) {
        throw "Não foi possivel acessar o pedido!";
      }

      this.preloader = false;
    },
    async reloadOrder() {
      this.order = await this.getOrder(this.$route.params.id);
      this.payments = this.order.payments;
    }
  },
  async mounted() {
    await this.reloadOrder();
  }
};
</script>

<template>
  <div>
    <div v-if="this.preloader" class="text-xs-center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-container
      v-if="!this.preloader && this.order"
      fluid
      grid-list-md
      class="box"
    >
      <div class="title header">
        PEDIDO
        <Events :events="this.order.events" />
      </div>
      <OrderDetails :order="this.order" @refresh="reloadOrder()" />
    </v-container>

    <v-container
      v-if="!this.preloader && this.order"
      fluid
      grid-list-md
      class="box"
    >
      <div v-if="this.payments.length > 0" class="title">PAGAMENTOS</div>
      <OrderPayments
        v-if="this.payments.length > 0"
        :payments="this.payments"
      />
      <div v-if="this.payments.length <= 0" class="title">
        NENHUM PAGAMENTO REGISTRADO
      </div>
    </v-container>
  </div>
</template>

<style scoped>
.preloader-page {
  height: 100%;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/ShowOrder/Index.vue